import { useState, useEffect } from 'react';
import MailingListModal from './MailingListModal';
import ContactModal from './ContactModal';

// Global modal manager that exposes functions to window object
function GlobalModalManager() {
  const [mailingListOpen, setMailingListOpen] = useState(false);
  const [contactOpen, setContactOpen] = useState(false);

  useEffect(() => {
    // Expose functions to window object for use in HTML pages
    window.openMailingListModal = () => {
      setMailingListOpen(true);
    };

    window.openContactModal = () => {
      setContactOpen(true);
    };

    // Cleanup on unmount
    return () => {
      delete window.openMailingListModal;
      delete window.openContactModal;
    };
  }, []);

  return (
    <>
      <MailingListModal isOpen={mailingListOpen} onClose={() => setMailingListOpen(false)} />
      <ContactModal isOpen={contactOpen} onClose={() => setContactOpen(false)} />
    </>
  );
}

export default GlobalModalManager;
